module.exports = __webpack_public_path__ + "img/program-closed.75460a9e.png";